import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { useLanguage } from '../../lib/LanguageContext';

export const Trust = () => {
  const { t } = useLanguage();
  return (
    <section id="trust" data-testid="trust-section" className="py-16 md:py-20 bg-sand-50">
      <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="text-xs uppercase tracking-[0.24em] text-sand-600 mb-6">{t.trust.eyebrow}</div>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-ink-900 leading-[1.1] mb-8">
          {t.trust.title}
        </h2>
        <p className="text-base md:text-lg text-ink-500 leading-relaxed mb-10 max-w-2xl">
          {t.trust.body}
        </p>
        <div className="flex flex-wrap gap-3">
          {t.trust.pills.map((p, i) => (
            <span
              key={i}
              data-testid={`trust-pill-${i}`}
              className="inline-flex items-center gap-2 px-4 py-2 bg-cream border border-sand-200 rounded-sm text-sm text-ink-700"
            >
              <ShieldCheck className="w-3.5 h-3.5 text-olive-500" strokeWidth={1.6} />
              {p}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Trust;
